import { Contract, PriceList, Stake, Token } from '@jdiyield/interfaces'
import throat from 'throat'
import Web3 from 'web3'

import networkRewardABI from '../abi/NetworkReward.json'
import { calculate } from '../calculate'
import getNodeUrl from '../rpcRandom'
import { findToken, makeBatchRequest } from '../utils'

export const get50CentFarm = async (
  walletAddress: string,
  ct: Contract,
  tokens: Token[],
  priceList: PriceList,
  web3Prop: Web3
): Promise<Stake[]> => {
  try {
    const { contractAddress, rewardAddress, routerAddress, pendingReward } = ct
    const web3 = web3Prop || new Web3(getNodeUrl(137))
    const contract = new web3.eth.Contract(networkRewardABI as any, contractAddress)

    const _poolLength = 4
    const poolArray = [...Array(_poolLength)]

    let _userInfoResults = []

    _userInfoResults = await makeBatchRequest(
      web3,
      poolArray.map((_data, poolId) => {
        return contract.methods.userInfo(poolId, walletAddress).call
      })
    )

    const _balances = _userInfoResults.map((result, poolId) => {
      let balance = '0' as any
      balance = result['amount']
      return { pool: poolId, balance: balance || '0' }
    })
    const poolWhiteList = _balances.filter(({ balance }) => +balance > 0).map(({ pool }) => pool)
    const filteredBalance = _balances.filter(({ pool }) => poolWhiteList.includes(pool))
    const _balancesLP = await makeBatchRequest(
      web3,
      filteredBalance.map((b) => contract.methods.poolInfo(b.pool).call)
    )
    const _balancesLPResult = _balancesLP.map((obj, i) => ({ ...filteredBalance[i], lpAddress: obj['lpToken'] }))
    const _balanceLPPair = _balancesLPResult.map(
      throat(80, async (lp: any) => {
        return calculate(
          web3,
          {
            ...lp,
            rewardAddress
          },
          routerAddress,
          tokens,
          priceList
        )
      })
    )

    //? should batch for performance?
    // const _balanceYourLNotStake = _balancesLPResult
    //   .filter(({ pool }) => poolWhiteList.includes(pool))
    //   .map(async (lp) => {
    //     try {
    //       const contract = new web3.eth.Contract(UniswapV2PairABI as any, lp.lpAddress)
    //       const [_availableBalanceOf, decimals] = await makeBatchRequest(web3, [
    //         contract.methods.balanceOf(walletAddress).call,
    //         contract.methods.decimals().call
    //       ])
    //       const availableBalanceOf = new BigNumber(_availableBalanceOf).dividedBy(`1e${decimals ?? 18}`)
    //       return {
    //         ...lp,
    //         availableBalanceOf
    //       }
    //     } catch (error) {
    //       console.log(error)
    //       return null
    //     }
    //   })

    const _pendingReward = async () => {
      try {
        const result = await makeBatchRequest(
          web3,
          _balancesLPResult
            .filter(({ pool }) => poolWhiteList.includes(pool))
            .map((lp) => {
              return contract.methods[`${pendingReward}`](lp.pool, walletAddress).call
            })
        )
        return result.map((reward, index) => ({ ..._balancesLPResult[index], reward }))
      } catch (error) {
        return _balancesLPResult.map((lp) => ({ ...lp, reward: 0 }))
      }
    }

    const [completeBalance, completePendingReward] = await Promise.all([
      Promise.all(_balanceLPPair),
      // Promise.all(_balanceYourLNotStake),
      _pendingReward()
    ])
    const rewardSymbol = findToken(tokens, rewardAddress)?.symbol ?? '???'
    const result = completeBalance
      .filter((obj) => obj !== null)
      .map((i) => {
        // const availableBalanceOf =
        //   completeBalanceNotStake.find((a: any) => a.pool === i.pool)?.availableBalanceOf || '0'
        const reward = +completePendingReward?.find((a: any) => a.pool === i.pool)?.reward / 1e18 || 0
        return {
          ...i,
          ...ct,
          availableBalanceOf: '0',
          reward,
          rewardSymbol
        } as Stake
      })
    return result
  } catch (e) {
    console.log(e)
    return []
  }
}
